'use client'
import React, { FC } from 'react'
import { Button, Icon, IconButtonProps } from '@chakra-ui/react'
import { TbDeviceMobileMessage } from 'react-icons/tb'

interface ContactButtonProps extends Partial<IconButtonProps> {}

const ContactButton: FC<ContactButtonProps> = ({ ...props }) => {
  const handleContactClick = () => {
    const contactSection = document.getElementById('contacto')
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <Button
      aria-label="contact"
      borderColor="primary"
      borderWidth={1}
      h={8}
      fontSize="sm"
      onClick={handleContactClick}
      leftIcon={<Icon as={TbDeviceMobileMessage} boxSize={4} />}
      {...props}>
      Comunicarse con el broker
    </Button>
  )
}

export default ContactButton
